module.exports = __webpack_public_path__ + "img/powered-by-twism.f8e8d5eb.svg";